import { Befehl } from '../models'
import {
  findAuftrag,
  hasEitherFieldContent,
  hasField,
  hasFieldContent
} from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 5 has empty fields.
 *
 * First checks if ANY field is empty (generic check).
 * Then checks specific business rules:
 * - 5.41 is always enabled (non-removable auftrag)
 * - 5.42.1 km/h is optional
 * - Location type: 5.43 alone = "in", 5.43+5.44 = "zwischen"
 * - von/bis distance fields required when location type chosen
 * - Each distance needs either km OR signal
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl5EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag541 = findAuftrag(befehl, '5.41')

  if (!auftrag541) {
    return false
  }

  const has543 = hasField(auftrag541, '5.43')
  const has544 = hasField(auftrag541, '5.44')
  const hasSelectorFields = has543 || has544

  // If selector fields are present, 5.43 must have content
  if (
    hasSelectorFields &&
    (!hasFieldContent(auftrag541, '5.43', 'zugmeldestelle.name') ||
      !hasFieldContent(auftrag541, '5.43', 'zugmeldestelle.art'))
  ) {
    return true
  }

  // If 5.44 exists, it must have content (zwischen mode)
  if (
    has544 &&
    (!hasFieldContent(auftrag541, '5.44', 'zugmeldestelle.name') ||
      !hasFieldContent(auftrag541, '5.44', 'zugmeldestelle.art'))
  ) {
    return true
  }

  // If selector fields are present, von (5.47) must have either km or signal
  if (
    hasSelectorFields &&
    !hasEitherFieldContent(auftrag541, '5.47.1', 'km', '5.47.2', 'signal')
  ) {
    return true
  }

  // If selector fields are present, bis (5.48) must have either km or signal
  if (
    hasSelectorFields &&
    !hasEitherFieldContent(auftrag541, '5.48.1', 'km', '5.48.2', 'signal')
  ) {
    return true
  }

  return false
}
